import 'babel-polyfill'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/plugins/vue-cookies'
import ApiService from '@/services/ApiService'
import ErrorHandlingService from '@/services/ErrorHandlingService'

Vue.config.productionTip = false

ErrorHandlingService.init(store)
ApiService.init(store, router)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
